import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Button,
  Grid,
} from 'antd';

import {
  ArrowLeftOutlined,
  PrinterFilled,
} from '@ant-design/icons';

const ModalPrintControls = ({
  onCancel,
  onPrint,
  loading,
}) => {
  const screens = Grid.useBreakpoint();
  return (
    <Row className="form-submit-controls">
      <Button
        type="link"
        onClick={onCancel}
        disabled={loading}
      >
        <ArrowLeftOutlined />
        {screens.md && 'Cancelar'}
      </Button>
      <Button
        type="link"
        onClick={onPrint}
        disabled={loading}
        style={{ marginLeft: 10 }}
        className="submit-print"
        autoFocus
      >
        <PrinterFilled />
        {screens.md && 'Imprimir'}
      </Button>
    </Row>
  );
};

ModalPrintControls.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

ModalPrintControls.defaultProps = {
  loading: false,
};

export default ModalPrintControls;
